module.exports = __webpack_public_path__ + "static/media/Inter-Bold.df74d442.otf";